import { makeStyles } from '@material-ui/core';
import { deepOrange } from '@material-ui/core/colors';
import { observer } from 'mobx-react';
import React from 'react';
import { transl } from '../../../main/transl';
import { IDataviewStore } from '../../../stores/DataviewStore';
import { SupplierItemExtended } from './SupplierItemExtended';

const useStyles = makeStyles((theme) => ({
	element: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
	},
	isUnharmonized: {
		color: '#000',
		padding: '10px 5px',
		borderRadius: 15,
		backgroundColor: '#FF9800',
	},
	isHarmonized: {
		color: '#000',
		padding: '10px 5px',
		borderRadius: 15,
		backgroundColor: '#4CAF50',
	},
}));

const Element = observer(function Element(props: {isHarmonized: boolean}) {
	const classes = useStyles();
	return <div className={classes.element}>
		{!props.isHarmonized
			? <div className={classes.isUnharmonized}>{transl('isUnharmonized')}</div>
			: <div className={classes.isHarmonized}>{transl('isHarmonized')}</div>}
	</div>;
});

export const HarmoStatus = observer(function HarmoStatus(props: {entity: SupplierItemExtended, state: IDataviewStore}) {
	const classes = useStyles();
	const {entity} = props;
	const s = entity.harmoStatus;
	return s==='0/-1' ? <Element isHarmonized={false}/>
		: s==='1/-1' ? <Element isHarmonized={true}/>
			: <div>{s}</div>;
});
